// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__RNUhn","bookmarkLink":"style__bookmarkLink__UmUcn","disabled":"style__disabled__gWltW"};